export default __webpack_public_path__ + "static/media/wda_bridge_overal.c9b28dfd.jpeg";